/**
 * @private
 * @sw-package fundamentals@after-sales
 */
Shopware.Component.extend(
    'swag-migration-profile-shopware57-local-credential-form',
    'swag-migration-profile-shopware-local-credential-form',
    {},
);
